module.exports = __webpack_public_path__ + "static/media/aci.7abcdc45.png";